module.exports = __webpack_public_path__ + "img/design01.c0e0cb97.png";